<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    let myData1 = [
      {
        value: 31984,
        name: "高中",
      },
      {
        value: 58644,
        name: "初中",
      },
      {
        value: 107817,
        name: "小学",
      },
      {
        value: 2031,
        name: "职业学校",
      },
      {
        value: 34952,
        name: "幼儿园",
      },
    ];
    let colorA = ["#F26C4F", "#0897DD", "#BEFCFC", "#00E1EF", "#ABD0BC"];
    this.state.chart.setOption({
      title: {
        text: " 235428  \n 全县学生",

        top: "35%",
        left: "11%",
        textStyle: {
          fontSize: 28,
          color: "#ffffff",
        },
      },
      legend: {
        orient: "vertical",
        icon: "circle",
        right: "1%",

        y: "center",
        itemWidth: 20,
        itemHeight: 20,
        itemGap: 30,
        align: "left",
        textStyle: {
          rich: {
            name: {
              // width: '45%',
              fontSize: 24,
              color: "#fff",
            },
            value: {
              fontSize: 24,
              padding: [0, 5, 0, 15],
              color: "#00E1EF",
            },
          },
        },
        formatter: function (name) {
          let res = myData1.filter((v) => v.name === name);
          res = res[0] || {};
          const p = res.value;
          return "{name|" + name + "：}" + "{value|" + p + "人}";
          // return "{name|" + name + "}";
        },
      },
      tooltip: {
        show: false,
        confine: true,
        trigger: "item",
        formatter: "{b} : {c}",
      },
      series: [
        {
          avoidLabelOverlap: false,
          type: "pie",
          roseType: "area", // 玫瑰图
          center: ["20%", "50%"],
          radius: ["70%", "46%"],
          color: colorA,
          itemStyle: {
            normal: {
              borderColor: "#050F20",
              borderWidth: 3,
            },
          },
          label: {
            normal: {
              show: false,
              //   formatter: '{b}\n{d}%\t{c}',
              formatter: "{b|{b}}\n{d|{d}%}",
              rich: {
                icon: {
                  fontSize: 20,
                },
                d: {
                  fontSize: 20,
                  padding: [5, 0, 0, 0],
                  color: "#fff",
                },
                b: {
                  fontSize: 20,
                  padding: [0, 0, 5, 0],
                  color: "#fff",
                },
              },
            },
          },
          labelLine: {
            normal: {
              length: 10,
              length2: 25,
            },
          },
          data: myData1,
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
